import { FormControl, FormGroup } from '@angular/forms';
import { Nillable } from '@web/utils';

export class AdminSubscriptionBulkPriceChangeForm {
  public static PriceMin = 0;

  public constructor(
    private readonly data: {
      price: number;
    },
  ) {}

  public get price(): number {
    return this.data.price;
  }
}

export type AdminSubscriptionBulkPriceChangeFormGroup = FormGroup<{
  price: FormControl<Nillable<number>>;
}>;
